<template>
  <div>
    <SubTitle text="Verificación"/>
    <div class="card-section">
      <el-row>
        <!-- validate general config -->
        <el-col :span="8" class="section-validation">
          <i :class='this.extraData.length > 0 ? "el-icon-warning" : "el-icon-success"'/>
          <p class="title">DATOS GENERALES</p>
          <div class="item-err">
            <p v-for="(error, index) in this.extraData" :key="index">
              <i class="el-icon-arrow-right"/>{{error}}
            </p>
          </div>
          <p v-if="this.extraData.length === 0">¡Verificación exitosa!</p>
        </el-col>
        <!-- validate sectors -->
        <el-col :span="8" class="section-validation">
          <i :class='this.sectors.length > 0 ? "el-icon-warning" : "el-icon-success"'/>
          <p class="title">SECTORES</p>
          <div class="item-err">
            <p v-for="(error, index) in this.sectors" :key="index">
              <i class="el-icon-arrow-right"/>{{error}}
            </p>
          </div>
          <p v-if="this.sectors.length === 0">¡Verificación exitosa!</p>
        </el-col>
        <!-- validate suborders -->
        <el-col :span="8" class="section-validation">
          <i :class='this.suborders.length > 0 ? "el-icon-warning" : "el-icon-success"'/>
          <p class="title">SUBORDENES</p>
          <div class="item-err">
            <p v-for="(error, index) in this.suborders" :key="index">
              <i class="el-icon-arrow-right"/>{{error}}
            </p>
          </div>
          <p v-if="this.suborders.length === 0">¡Verificación exitosa!</p>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import SubTitle from '../../base/SubTitle.vue';

export default {
  props: {
    sectors: {
      type: Array,
      default() {
        return [];
      },
    },
    extraData: {
      type: Array,
      default() {
        return [];
      },
    },
    suborders: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  name: 'PlanningCheck',
  components: {
    SubTitle,
  },
  data() {
    return {
    };
  },
  watch: {
    sectors() {
      this.$emit('validPlanning', this.validPlanning);
    },
    extraData() {
      this.$emit('validPlanning', this.validPlanning);
    },
  },
  computed: {
    validPlanning() {
      return this.sectors.length === 0 && this.extraData.length === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
  .card-section {
    text-align: center;
    // border: 1px solid #E0E0E0;
    padding: 20px 10px 10px 10px;
    .section-validation {
      color: #2c3e50;
      font-size: 14px;
      i { font-size: 32px; }
      .title {
        font-weight: 900;
        margin: 7px 0 10px 0;
        color: #666;
      }
      .item-err {
        margin-bottom: 10px;
        p {
          margin: 2px 0 0 0;
          color: #666;
        }
        i {
          font-size: 12px;
          font-weight: 900;
          margin-right: 5px;
        }
      }
      .el-icon-warning { color: $fb-amber; }
      .el-icon-success { color: $fb-green-light-30; }
    }
  }
</style>
